import { render, staticRenderFns } from "./upgrade-craft.vue?vue&type=template&id=8c2732aa&"
import script from "./upgrade-craft.vue?vue&type=script&lang=js&"
export * from "./upgrade-craft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports